// Transmission list signup — grows the newsletter list inside sealed application pages.
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Radio } from "lucide-react";
import { subscribeNewsletter, newsletterCount, errText } from "@/lib/api";

export const TransmissionListSignup = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [count, setCount] = useState(null);

  useEffect(() => {
    newsletterCount().then((d) => setCount(d.count)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await subscribeNewsletter(email.trim());
      setDone(true);
      setCount((c) => (c == null ? c : c + 1));
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto mt-8 max-w-md border border-gold/25 bg-onyx/70 p-5" data-testid="transmission-list-signup">
      {done ? (
        <div className="text-center" data-testid="transmission-list-success">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.35em] text-gold">
            <span className="mr-2 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-gold align-middle" aria-hidden="true" />
            You're on the list
          </p>
          <p className="mt-2 font-body text-sm text-silver/80">The Architect will signal you the moment the window unseals.</p>
          {count != null && count > 0 && (
            <p className="mt-2 font-mono text-[9px] font-bold uppercase tracking-[0.3em] text-goldlight" data-testid="operatives-count-done">
              {count} operative{count === 1 ? "" : "s"} on the list — you're one of them
            </p>
          )}
        </div>
      ) : (
        <>
          <p className="text-center font-mono text-[9px] uppercase tracking-[0.35em] text-gold">
            <Radio size={11} className="mr-1.5 inline align-middle" /> Join the transmission list
          </p>
          <p className="mt-2 text-center font-body text-sm text-silver/75">Be the first to know the moment this window unseals.</p>
          {count != null && count > 0 && (
            <p className="mt-2 text-center font-mono text-[9px] font-bold uppercase tracking-[0.3em] text-goldlight" data-testid="operatives-count">
              <span className="mr-1.5 inline-block h-1 w-1 animate-pulse rounded-full bg-gold align-middle" aria-hidden="true" />
              {count} operative{count === 1 ? "" : "s"} on the list
            </p>
          )}
          <form onSubmit={submit} className="mt-4 flex flex-col gap-2 sm:flex-row">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com" data-testid="transmission-list-email-input"
              className="flex-1 border border-silver/30 bg-charcoal px-4 py-2.5 font-body text-sm text-cream placeholder:text-silver/40 focus:border-gold focus:outline-none"
            />
            <button type="submit" disabled={busy} data-testid="transmission-list-submit-btn"
              className="btn-sweep border border-gold bg-gradient-to-b from-goldlight to-gold px-5 py-2.5 font-head text-xs font-extrabold uppercase tracking-[0.2em] text-onyx transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-60">
              {busy ? "Signing..." : "Signal Me"}
            </button>
          </form>
        </>
      )}
    </div>
  );
};
